import {
  capitalizeFirstLetter,
  getTestTypeForHeap,
  isComboOrder,
  snakeCaseToCapitalizedWords,
} from "@app/utils";
import { Order } from "@app/provider/order";
import { TestType } from "@app/provider/testData/types";

export const getTestNameForHeap = (
  orderData: Order | undefined
): string | undefined => {
  const testType = orderData && getTestTypeForHeap(orderData);
  const isCombo = orderData && isComboOrder(orderData);

  return isCombo ? testType : snakeCaseToCapitalizedWords(testType);
};

export const getTestNameForHeapByTestType = (testType: TestType) => {
  return testType === TestType.SINGLE_GENE_NIPT
    ? "Fetal_Focus"
    : capitalizeFirstLetter(testType);
};
